var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssessments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M366.42 370.64h-88.8l-16.5 40.8h-60.6l92.7-210h58.5l93 210h-61.8zm-17.4-43.8-27-67.2-27 67.2z",
    style: {
      fill: "gray"
    },
    transform: "translate(-310.235 -310.4) scale(2.03003)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.755,
    cy: 347.919,
    r: 41.717,
    style: {
      strokeWidth: 2.03003,
      fill: "#65ab65"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.537,
    cy: 462.088,
    r: 41.717,
    style: {
      strokeWidth: 2.03003,
      fill: "#de7c73"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153.972,
    cy: 233.75,
    r: 41.717,
    style: {
      strokeWidth: 2.03003,
      fill: "#48b2d2"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.17,
    cy: 119.581,
    r: 41.717,
    style: {
      strokeWidth: 2.03003,
      fill: "#e79933"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessments);
export default __webpack_public_path__ + "static/media/assessments.b9099ddad791e897f2ce06ca00d6dad1.svg";
export { ForwardRef as ReactComponent };